import { faArrowsUpDownLeftRight } from '@fortawesome/pro-regular-svg-icons'
import { Box, styled, Typography } from '@mui/material'
import { memo, type FC } from 'react'
import { Icon } from '../../Icon/Icon'

export interface RowDragPreviewProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any
}

// This drag preview is rendered in CustomDragLayer
export const RowDragPreview: FC<RowDragPreviewProps> = memo(({ item }) => {
  const dragCount = item?.rows?.length ?? 0

  return (
    <StyledBox>
      <StyledIcon icon={faArrowsUpDownLeftRight}/>
      <Typography variant="body1">
        {dragCount} Rows
      </Typography>
    </StyledBox>
  )
}, (prevProps, nextProps) => (prevProps.item.id === nextProps.item.id))


const StyledBox = styled(Box)`
  display: inline-flex;
  align-items: center;
  max-width: ${({ theme }) => theme.typography.pxToRem(200)};
  border-radius: ${({ theme }) => theme.typography.pxToRem(4)};
  padding: ${({ theme }) => theme.typography.pxToRem(10)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);
  cursor: grabbing;
`

const StyledIcon = styled(Icon)`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  margin-right: ${({ theme }) => theme.typography.pxToRem(4)};
`
